require.register("collection/app", function(exports, require, module){
  $0
  
});

